import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

/**
 * QualifyingMessage — pure presentational atom shown when the S&D campaign
 * uses `criteriaType === 'pluQuantity'`. V7 dictates no progress bar in this
 * case, so we render the message + CTA inside the same pill container used by
 * the progress-bar variant: a horizontal row with the qualifying message on
 * the left and an underlined CTA on the right.
 */
const QualifyingMessage = ({ qualifyingMessage, cta }) => (
  <Container data-testid="surprise-and-delight-qualifying-message">
    <MessageWrapper>
      <Message>{qualifyingMessage}</Message>
    </MessageWrapper>
    {cta && <Cta>{cta}</Cta>}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
  background: #f7f1ee;
  border-radius: 8px;
  padding: 16px 20px;
`;

const MessageWrapper = styled.div`
  flex: 1 0 0;
`;

const Message = styled.p`
  margin: 0;
  font-family: Barlow;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  color: #000;
`;

const Cta = styled.p`
  margin: 0;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #000;
  text-decoration: underline;
  text-underline-position: from-font;
  white-space: nowrap;
  flex-shrink: 0;
`;

QualifyingMessage.propTypes = {
  qualifyingMessage: PropTypes.string.isRequired,
  cta: PropTypes.string,
};

QualifyingMessage.defaultProps = {
  cta: '',
};

export { QualifyingMessage };
